// components/About.js
import React from 'react';
import './About.css';
import Hb from "../asste/images/home/hb.png"

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2>关于我们</h2>
            <p>天津勃昂环保科技有限公司是一家专注于企业环保领域的专业服务机构，致力于为各类企业提供全面、专业的环保技术咨询与工程服务。</p>
            <p>公司拥有一支经验丰富的专业技术团队，具备扎实的理论基础和丰富的实践经验。我们始终坚持以客户需求为导向，以技术创新为动力，为客户提供高效、可靠的环保解决方案。</p>
            <p>自成立以来，我们已成功为众多企业提供了环保咨询服务、环保设备安装与运维、污染源在线监测系统建设与维护、污水处理站运营以及定制化软件开发等服务，赢得了客户的广泛认可和好评。</p>
            <div className="mission">
              <h3>我们的使命</h3>
              <p>帮助企业实现环保合规，降低环境风险，提升可持续发展能力</p>
            </div>
          </div>
          <div className="about-image">
            <img src={Hb} alt="环保科技" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;